import { render, staticRenderFns } from "./交易项目详情_阶梯竞价版本.vue?vue&type=template&id=3a8b7830&scoped=true"
import script from "./交易项目详情_阶梯竞价版本.vue?vue&type=script&lang=js"
export * from "./交易项目详情_阶梯竞价版本.vue?vue&type=script&lang=js"
import style0 from "./交易项目详情_阶梯竞价版本.vue?vue&type=style&index=0&id=3a8b7830&prod&lang=css"
import style1 from "./交易项目详情_阶梯竞价版本.vue?vue&type=style&index=1&id=3a8b7830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b7830",
  null
  
)

export default component.exports